export const CUSTOM_MTX_DATETIME_FORMATS = {
    parse: {
        dateInput: "LLL d, yyyy",
        monthInput: "LLL",
        yearInput: "yyyy",
        datetimeInput: "LLL d, yyyy HH:mm",
        timeInput: "HH:mm",
    },
    display: {
        dateInput: "LLL d,yyyy",
        monthInput: "LLLL",
        yearInput: "yyyy",
        datetimeInput: "LLL d, yyyy HH:mm",
        timeInput: "HH:mm",
        monthYearLabel: "yyyy",
        dateA11yLabel: "DDD",
        monthYearA11yLabel: "LLLL yyyy",
        popupHeaderDateLabel: "LLL d, yyyy",
    },
};
